import { createOnsiteInterviews } from './CreateOnsiteInterviews';
import { createOrPublishJobPosting } from './CreateOrPublishJobPosting';
import { getCandidates } from './GetCandidates';
import { getOnsiteInterviewList } from './GetOnsiteInterviewList';
import { getPaymentPlans } from './GetPaymentPlans';
import { getPostingDetails } from './GetPostingDetails';
import { removeShortlistCandidate } from './RemoveShortlistCandidate';
import { shortlistCandidate } from './ShortlistCandidate';
import { updateCandidateStatus } from './UpdateCandidateStatus';
import { updateJobPosting } from './UpdateJobPosting';

/**
 * Payment Plans API Client
 * Provides low-level HTTP calls to payment plan endpoints
 */
export const PaymentPlansApi = {
  getPaymentPlans,
};

/**
 * Permanent Jobs API Client
 * Provides low-level HTTP calls to permanent jobs endpoints
 */
export const PermanentJobsApi = {
  createOnsiteInterviews,
  createOrPublishJobPosting,
  getCandidates,
  getOnsiteInterviewList,
  getPostingDetails,
  removeShortlistCandidate,
  shortlistCandidate,
  updateCandidateStatus,
  updateJobPosting,
};
